export default __webpack_public_path__ + "static/media/apple.98499f33.svg";